import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SoundKitListModel } from '../../models/sound-kit-list.model';
import { SoundKitService } from '../../services/sound/sound-kit.service';
import { FinalFilterModel } from '../../models/filter';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pro-kits-list',
  templateUrl: './pro-kits-list.component.html',
  styleUrls: ['./pro-kits-list.component.scss']
})
export class ProKitsListComponent implements OnInit, OnDestroy {
  proKitsList: Array<SoundKitListModel> = [];
  isDataLoaded: boolean = false;
  isShowLoaderPagination: boolean = false;
  isShowFilter: boolean = true;
  filterData: FinalFilterModel;
  countOfData: number = 0;
  paginationSubscription: Subscription;

  constructor(
    public commonFunction: CommonService,
    public routerActivated: ActivatedRoute,
    private router: Router,
    private soundKitService: SoundKitService
  ) {}

  ngOnInit(): void {
    // Set page title
    this.routerActivated.data.subscribe((data: any) => {
      this.commonFunction.setTitleService(data['title']);
    });

    // Initialize filter data
    this.filterData = this.soundKitService.filterDataInit();
    
    // Load Pro Kits data
    this.loadProKits();

    // Setup pagination subscription
    this.paginationSubscription = this.commonFunction.isCallingPagination.subscribe((res: boolean) => {
      this.isCallingPagination();
    });
  }

  ngOnDestroy(): void {
    if (this.paginationSubscription) {
      this.paginationSubscription.unsubscribe();
    }
  }

  isCallingPagination(): void {
    let url: string = this.router.url.split('/')[this.router.url.split('/').length - 1];
    if (this.proKitsList.length > 0 && 
        this.countOfData !== 0 &&
        this.countOfData === this.filterData.page.limit &&
        this.commonFunction.isCheckCurrentUrlMatch(url)) {
      let currentLimit: any = this.filterData.page.offset + this.filterData.page.limit;
      if (currentLimit) {
        this.filterData.page.offset = currentLimit;
        this.loadProKits('pagination');
      }
    }
  }

  loadProKits(callingType: string = ''): void {
    let isShowLoader = callingType && callingType === 'pagination' ? false : true;
    this.isDataLoaded = !isShowLoader;
    this.isShowLoaderPagination = callingType && callingType === 'pagination' ? true : false;
    
    this.soundKitService.getProKitList(this.filterData, isShowLoader).subscribe({
      next: (result) => {
        this.setProKitsList(result, callingType);
      },
      error: (error) => {
        this.commonFunction.showToastError(error);
        this.isDataLoaded = true;
        this.isShowLoaderPagination = false;
      }
    });
  }

  setProKitsList(proKitsList: Array<SoundKitListModel>, callingType: string): void {
    if (proKitsList.length > 0) {
      if (!callingType) {
        this.proKitsList = proKitsList;
      } else {
        this.proKitsList = [...this.proKitsList, ...proKitsList];
      }
    }
    this.countOfData = proKitsList.length;
    this.isDataLoaded = true;
    this.isShowLoaderPagination = false;
  }

  goBack(): void {
    this.router.navigate(['/soundkits']);
  }
}
